const UNKNOWN_LANGUAGE = 'unknown';
const DEFAULT_LANGUAGE = '';

export {UNKNOWN_LANGUAGE, DEFAULT_LANGUAGE};
